import CommonColorMapping from "./CommonColorMapping";
import SoftballPitchPlayerColors from '@/enums/SoftballPitchColors';

/**
 * Softball override
 * @see https://www.figma.com/design/wmbWfgrrs8XzqRUzSZkXV7/FS-Baseball---Settings?node-id=2423-6667&t=GS7IBufy8W368uQ1-0
 * @type {ColorMap}
 */
export const SoftballPitchTypeSeriesColorMapping = {
  ...SoftballPitchPlayerColors,
  ...CommonColorMapping,
};
